module.exports = __webpack_public_path__ + "media/packs/images/flags/BS-1f13e83bf968921eede3d09f1bd2d922.svg";